<template>
  <div class="addAccount">
    <!--新增-->
    <el-dialog
      :title="$t('account.insertTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="580px"
    >
      <el-form
        label-width="auto"
        ref="insertDialog"
        :inline="true"
        :label-position="'right'"
        :rules="rules"
        :model="addInfo"
      >
        <!-- <el-form-item label="角色类型" prop="partnerType">
          <el-select
            :placeholder="$t('menu.partnerTypePlaceholder')"
            v-model="addInfo.partnerType"
            clearable
            filterable
            value-key="id"
            @change="partnerTypeChange"
            class="inputWidth"
          >
            <el-option
              v-for="item in [{value:'HZHB01',label:'客户'},{value:'HZHB02',label:'供应商'},{value:'HZHB03',label:'合作伙伴'}]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="合作伙伴" prop="userAcct">
          <el-select
            :placeholder="$t('account.userAcctPlaceholder')"
            v-model="addInfo.userAcct"
            clearable
            filterable
            value-key="id"
            remote
            :remote-method="remoteMethod"
            @change="userChange"
            class="inputWidth"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.partnerZhName + '-' + item.departmentName + '-' + item.partnerTypeName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作伙伴类型" prop="userPartnerType">
          <el-input
            v-model="addInfo.userPartnerType"
            class="inputWidth"
            :placeholder="$t('account.emailPlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.accountName')" prop="accountName">
          <el-select
            :placeholder="$t('account.accountNamePlaceholder')"
            v-model="addInfo.accountName"
            clearable
            filterable
            value-key="id"
            @change="accountChange"
            class="inputWidth"
          >
            <el-option
              v-for="item in partnersPersons"
              :key="item.id"
              :label="item.mobilePhone"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.sex')" prop="sex">
          <el-select
            class="inputWidth"
            :placeholder="$t('account.sexPlaceholder')"
            v-model="addInfo.sex"
            filterable
          >
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.phone')" prop="phone">
          <el-input
            v-model="addInfo.phone"
            class="inputWidth"
            :placeholder="$t('account.phonePlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email')" prop="email">
          <el-input
            v-model="addInfo.email"
            class="inputWidth"
            :placeholder="$t('account.emailPlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.startValidityTime')" prop="startValidityTime">
          <el-date-picker
            v-model="addInfo.startValidityTime"
            type="date"
            class="inputWidth"
            value-format="yyyy-MM-dd"
            :placeholder="$t('account.startTimePlaceholder')"
            :picker-options="pickOptionBegin"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('account.endValidityTime')" prop="endValidityTime">
          <el-date-picker
            v-model="addInfo.endValidityTime"
            type="date"
            class="inputWidth"
            value-format="yyyy-MM-dd"
            :placeholder="$t('account.endTimePlaceholder')"
            :picker-options="pickOptionEnd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('account.remark')" prop="remark">
          <el-input
            type="textarea"
            :placeholder="$t('account.reamrkPlaceholder')"
            v-model="addInfo.remark"
            clearable
            style="width: 426px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/systemManage/account.js';
  import XEUtils from 'xe-utils';
  export default {
    name: 'addAccount',
    data() {
      return {
        dialogAdd: false,
        loading: false,
        userList: [], //合作伙伴
        partnersPersons: [], //合作伙伴联系人
        addInfo: {
          partnerType: null,
          userAcct: null,
          userId: '',
          accountName: '',
          email: '',
          sex: '',
          adminFlag: '2',
          startValidityTime: null,
          endValidityTime: null,
          remark: '',
          userPartnerType: '',
        },
        pickOptionBegin: {
          disabledDate: (time) => {
            if (this.addInfo.endValidityTime) {
              return time.getTime() >= new Date(this.addInfo.endValidityTime).getTime();
            }
          },
        },
        pickOptionEnd: {
          disabledDate: (time) => {
            if (this.addInfo.startValidityTime) {
              return (
                time.getTime() <=
                new Date(this.addInfo.startValidityTime).getTime() - 3600 * 24 * 1000
              );
            }
          },
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          partnerType: [
            {
              required: true,
              message: '请选择角色类型',
              trigger: 'change',
            },
          ],
          userAcct: [
            {
              required: true,
              message: this.$t('account.userAcctNotEmpty'),
              trigger: 'change',
            },
          ],
          sex: [
            {
              required: true,
              message: this.$t('account.userAcctNotEmpty'),
              trigger: 'change',
            },
          ],
          accountName: [
            {
              required: true,
              message: this.$t('account.userAcctNotEmpty'),
              trigger: 'change',
            },
          ],
          userName: [
            {
              required: true,
              message: this.$t('account.userAcctNotEmpty'),
              trigger: 'change',
            },
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
    },
    methods: {
      openDialog(flag) {
        if (this.$refs['insertDialog']) {
          this.$refs['insertDialog'].resetFields();
        }
        this.loading = false;
        this.dialogAdd = flag;
      },
      resetInfo(flag) {
        //01合作伙伴 02 用户账号
        if (flag == '01') {
          (this.partnersPersons = []), (this.addInfo.userAcct = null);
          this.addInfo.partnerCode = '';
          this.addInfo.partnerName = '';
          this.resetInfo('02');
        } else if (flag == '02') {
          this.addInfo.email = '';
          this.addInfo.userName = '';
          this.addInfo.accountName = '';
          this.addInfo.phone = '';
          this.addInfo.userId = '';
        }
      },
      partnerTypeChange(val) {
        console.log(val);
        //初始化用户数据t
        // this.getUserData();
        // this.resetInfo('01')
      },

      remoteMethod(query) {
        if (query !== '') {
          this.getUserData(query);
        } else {
          this.options = [];
        }
      },
      //
      getUserData: XEUtils.debounce(function (val) {
        const params = {
          // partnerType: this.addInfo.partnerType,
          companyCode: this.$globalVar.subserver.companyCode,
          partnerZhName: val,
          requestStatus: 'ZT03',
          distinctFlag: true,
        };
        this.loading = true;
        this.$axios.post(API.LIST_PARTNER_SEARCH, params).then((res) => {
          this.loading = false;
          if (0 == res.data.code) {
            this.userList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      }, 500),
      //选择用户下拉
      userChange(val) {
        this.addInfo.partnerCode = val.partnerCode;
        this.addInfo.partnerName = val.partnerZhName;
        this.addInfo.userPartnerType = this.$baseRequest.getDictValueByType(
          'partner_type',
          val.partnerType
        );
        this.getDetail(val);
        this.resetInfo('02');
      },
      //获取供应商联系人
      getDetail(value) {
        const params = {
          id: value.id,
          partnerCode: value.partnerCode,
          departmentCode: value.departmentCode,
        };
        this.$axios.get(API.GET_PARTNER_PERSON, params).then((res) => {
          if (res.data.code === 0) {
            this.partnersPersons = res.data.data || [];
            console.log(this.partnersPersons);
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //手机号变化
      accountChange(val) {
        this.addInfo.email = val.email;
        this.addInfo.userName = val.contactPersonName;
        this.addInfo.accountName = val.mobilePhone;
        this.addInfo.phone = val.mobilePhone;
        this.addInfo.userId = val.id;
        this.addInfo.userNo = '';
      },
      //保存
      addSure() {
        const params = JSON.parse(JSON.stringify(this.addInfo));
        this.$refs.insertDialog.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            delete params.userAcct;
            params.inoutFlag = 'O';
            params.tenantCode = this.userInfo.userInfo.tenantCode;
            this.$axios.post(API.ADD_ACCOUNT_API, params).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .inputWidth {
    width: 170px !important;
  }
</style>
